import React from 'react';
import PropTypes from 'prop-types';

class CheckGroup extends React.Component{

    static propTypes = {
        title: PropTypes.any,
        options: PropTypes.array,
        display: PropTypes.string,
        onSelect: PropTypes.func,
        disabled: PropTypes.bool
    };

    static defaultProps = {
        display: 'horizontal',
        options: []
    };

    constructor(props){
        super(props);

        this.state = {
            selection: props.options.filter(x => x.checked == true).map(x => props.options.indexOf(x) )
        };

        this._inputs = {};
    }

    getSelected(){

        const selection = this.getSelectedIndices();
        return this.props.options.filter((item,i) =>{
            return selection.indexOf(i) >= 0;
        });

    }

    getSelectedIndices(){
        return this.state.selection;
    }

    clearSelection(updateState = true){

        for(let i in this._inputs){
            this._inputs[i].checked = false;
        }

        if(updateState)
            this.setState({
                selection: []
            });

    }

    setSelectedValues(values){

        let indices = [];
        values.forEach(v => {

            const op = this.props.options.findIndex(x => x.value == v);
            if(op){
                indices.push(op);
            }

        });

        if(indices.length == 0){
            this.clearSelection();
        }
        else{
            this.setSelectionIndices(indices);
        }

    }

    setSelectionIndices(indices){

        if(Array.isArray(indices)){

            this.clearSelection(false);

            this.setState({

                selection: indices.filter(i => {

                    var option = this.props.options[i];
                    if(option){

                        var ref = this._inputs[option.name];
                        if(ref){
                            ref.checked = true;
                            return true;
                        }
                    }

                })
            });

        }

    }

    onChange(item,i,evt){

        const props = this.props;
        const checked = evt.target.checked;

        let selected = this.state.selection;
        if(checked){

            if(selected.indexOf(i) < 0)
                selected.push(i);

        }
        else{

            let f = selected.indexOf(i);
            if(f >= 0){
                selected.splice(f,1);
            }

        }

        this.setState({
            selection: selected
        });


        if(props.onSelect)
            props.onSelect(item,i,checked);

    }

    render(){

        const props = this.props;
        const options  = props.options;
        const me = this;

        let content;
        switch (props.display){
            case 'horizontal':
                content = <div>
                    {options.map((item,i) => {

                        return <label key={i}  className="form-check-inline">
                            <input type="checkbox" disabled={props.disabled} defaultChecked={item.checked} value={item.value} ref={(input) => { this._inputs[item.name]  = input }} onChange={this.onChange.bind(this,item,i)} /> {item.text}
                        </label>;

                    })}

                </div>;
                break;
            case 'vertical':
                content = <div>
                    {options.map((item,i) =>{

                        return (<div className="checkbox" key={i}>
                            <label>
                                <input disabled={props.disabled} type="checkbox" ref={(input) => { this._inputs[item.name]  = input }} defaultChecked={item.checked} onChange={this.onChange.bind(this,item,i)} value={item.value} /> {item.text}
                            </label>
                        </div>);
                    })}
                </div>;
                break;
        }

        return (<div> <label>{props.title}</label>{content}</div>);
    }

}

export default CheckGroup;


// WEBPACK FOOTER //
// ./src/common/FormRenderer/Controls/CheckGroup.js